import * as toastr from 'toastr'
import * as moment from 'moment'
import { UserTypes } from '@shared/enums';
import { VendasService } from './vendas.service';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ShowDiasFaltandoPeriodoVendasService {
  constructor(
    private clientesService: VendasService
  ){
  }

  execute(){
    const user = localStorage.getItem("user_logado");

    if(user){
      const userLogado = JSON.parse(user);

      if(userLogado.perfil == UserTypes.VENDEDOR){
        this.clientesService.getPeriodoPrevisaoVendas()
          .subscribe(
            (data)=> {
              if(data.dataFinalPrevisao){
                var date = moment(data.dataFinalPrevisao);
                var todaysdate = moment();
                const diasFaltando = date.diff(todaysdate, 'days');

                if(diasFaltando === 0){
                  toastr.warning(`Hoje é o último para a previsão de vendas do período`)
                }else{
                  toastr.warning(`Faltam ${diasFaltando} dias para o fim da previsão de vendas do período`)
                }
              }
            }
          )
      }
    }
  }
}
